import React, { useMemo } from "react";
import useApi from "../hooks/useApi";
import Layout from "../layouts/Default";
import NoItems from "../parts/NoItems";
import Loader from "../components/loaders/Loader";
import TypesContext from "../contexts/types";
import Checkbox from "../components/checkboxes/Checkbox";
import ProjectsList from "../parts/ProjectsList";

export default () => {
  const [selectedSkills, selectSkill] = React.useReducer(reduceSkills, []);
  const { skills: fetchedSkills } = React.useContext(TypesContext);
  const { data: projects, loading: loadingProjects } = useApi(
    "/users?role=contractor"
  );
  const filteredProjects = useMemo(
    () => filterProjects(projects, selectedSkills),
    [projects, selectedSkills]
  );
  const openProjects = useMemo(() => getOpenProjects(filteredProjects), [
    filteredProjects,
  ]);
  const openMissionsCount = useMemo(() => countOpenMissions(filteredProjects), [
    filteredProjects,
  ]);
  const closedProjects = useMemo(() => getClosedProjects(filteredProjects), [
    filteredProjects,
  ]);
  const closedMissionsCount = useMemo(
    () => countClosedMissions(filteredProjects),
    [filteredProjects]
  );

  return (
    <Layout noPadding title="Projects">
      <div className="pProjects">
        <h3 className="pProjects_count">
          {openMissionsCount
            ? `${openMissionsCount} design jobs`
            : "0 design job"}
        </h3>
        <h5>Skills needed</h5>
        <div className="pProjects_filters">
          {fetchedSkills &&
            fetchedSkills.map((skill, id) => (
              <Checkbox
                key={id}
                label={skill.name}
                special
                checked={selectedSkills.includes(`${skill.id}`)}
                setValue={() => selectSkill(`${skill.id}`)}
              />
            ))}
        </div>
        <div>
          {!loadingProjects && (
            <ProjectsList
              listClassname="pProjects_list"
              openProjects={openProjects}
              closedProjects={closedProjects}
              closedMissionsCount={closedMissionsCount}
            />
          )}
          {loadingProjects && <Loader />}
          {!projects ||
            projects.length === 0 ||
            ((!filteredProjects || filteredProjects.length === 0) && (
              <NoItems />
            ))}
        </div>
      </div>
    </Layout>
  );
};

const reduceSkills = (skills, skillId) => {
  if (skills.includes(skillId)) return skills.filter(id => id !== skillId);
  return [...skills, skillId];
};

const filterProjects = (projects = [], selectedSkills = []) =>
  projects
    ? projects
        .filter(project => {
          if (selectedSkills && selectedSkills.length > 0) {
            if (!project.skill) return false;
            return project.skill.some(s => selectedSkills.includes(s));
          }
          return true;
        })
        .sort(sortProjects)
    : [];

const sortProjects = (projectA, projectB) => {
  const dateA = new Date(projectA.most_recent_mission_date);
  const dateB = new Date(projectB.most_recent_mission_date);
  return dateB - dateA;
};

const getOpenProjects = (projects = []) =>
  projects.filter(project => project.missions_count > 0);

const getClosedProjects = (projects = []) =>
  projects.filter(project => project.closed_missions_count > 0);

const countOpenMissions = (projects = []) =>
  projects?.reduce((sum, { missions_count }) => missions_count + sum, 0);

const countClosedMissions = (projects = []) =>
  projects?.reduce(
    (sum, { closed_missions_count }) => closed_missions_count + sum,
    0
  );
